module.exports = __webpack_public_path__ + "static/img/tag-bg.307c02e7.png";